module.exports = __webpack_public_path__ + "static/media/0024.db11055a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48104/RAL/0024.png
// module id = 2460
// module chunks = 0